import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter.component';
import { FilterGroupComponent } from './filter-group.component';
import { FilterExpressionComponent } from './filter-expression.component';

@NgModule({
  declarations: [FilterComponent, FilterGroupComponent, FilterExpressionComponent],
  imports: [CommonModule],
  exports: [FilterGroupComponent]
})
export class FilterModule {}
